<template>
  <ul id="sispessoal-sidenav" ref="sidenav" class="sidenav hide-on-large-only">
    <li>
      <div v-if="isUserLoggedIn" class="user-view">
        <div class="background" v-bind:class="[color, luminosity]">
          <img v-if="user.backgroundImage" v-bind:src="user.backgroundImage" v-bind:alt="user.name"
            v-bind:title="user.name" />
        </div>
        <a href="#!">
          <img class="circle" v-if="user.photo" v-bind:src="user.photo" v-bind:alt="`Imagem de fundo de ${user.name}`"
            v-bind:title="`Imagem de fundo de ${user.name}`" />
        </a>
        <a href="#!">
          <span class="white-text name">{{ user.name }}</span>
        </a>
        <a href="#!">
          <span class="white-text email">{{ user.email }}</span>
        </a>
      </div>
    </li>
    <li>
      <TheAccessibilityMenu v-bind:class="[color, luminosity]" />
    </li>
    <li>
      <BaseRouterLink
        v-bind:to="{ name: 'containerHome' }"
        class="sidenav-close"
      >
        Início
      </BaseRouterLink>
    </li>
    <li v-show="isUserLoggedIn">
      <ul v-if="modulos" ref="collapsible" class="collapsible">
        <li>
          <a class="collapsible-header">Módulos</a>
          <div class="collapsible-body">
            <ul>
              <li v-for="(item, index) in modulos" v-bind:key="index">
                <BaseRouterLink class="sidenav-close" v-bind="item">{{
                  item.content
                }}</BaseRouterLink>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </li>
    <!--<li>
      <a href="#!" class="sidenav-close" v-on:click="openHelp">Ajuda</a>
    </li>-->
    <li v-if="isUserLoggedIn">
      <!--<BaseRouterLink
        class="sidenav-close"
        v-bind:to="{ name: 'containerMeusDados' }"
        >Meus Dados</BaseRouterLink
      >-->
      <router-link class="sidenav-close" to="/modulos/consulta-servidor/consulta-servidor">Meus Dados</router-link>
    </li>
    <li v-if="isUserLoggedIn && isAdmin">
      <BaseRouterLink
        class="sidenav-close"
        v-bind:to="{ name: 'containerControleAcesso' }"
        >Controle de Acesso
      </BaseRouterLink>
    </li>
    <li v-if="showModuloMenu" class="divider" tabindex="-1"></li>
    <li v-if="showModuloMenu">
      <TheHeaderSidenavModuloMenu
        v-bind:modulo-name="modulo.name"
        v-bind:modulo-menu="moduloMenu"
      />
    </li>
    <li class="expander" tabindex="-1"></li>
    <li class="divider" tabindex="-1"></li>
    <li v-if="isUserLoggedIn" class="logout-item">
      <a href="#" class="sidenav-close" v-on:click="logout">Sair</a>
    </li>
  </ul>
</template>

<script>
import {
  DEFAULT_COLOR,
  DEFAULT_LUMINOSITY,
} from "../constants";
import { AuthenticationService, ModuloService } from "../services";
import TheAccessibilityMenu from "./TheAccessibilityMenu.vue";
import TheHeaderSidenavModuloMenu from "./TheHeaderSidenavModuloMenu.vue";

export default {
  name: "TheHeaderSidenav",
  components: {
    TheAccessibilityMenu,
    TheHeaderSidenavModuloMenu
  },
  inheritAttrs: false,
  data() {
    return {
      color: DEFAULT_COLOR,
      luminosity: DEFAULT_LUMINOSITY,/*
      helpUrl: `${HELP_INFOTIC_URL}/duvidas-sistema/${APP_INFO.name}`,*/
      modulos: this.$store.state.modulos.map(value => ({
        ...ModuloService.mapToSidenavLink(value)
      }))
    };
  },
  computed: {
    modulo() {
      return this.$store.state.modulo;
    },
    moduloMenu() {
      return this.$store.state.moduloMenu;
    },
    isAdmin() {
      const permissions = this.$store.state.permissions;

      return !!permissions["ADMIN"] && permissions["ADMIN"].id;
    },
    isUserLoggedIn() {
      // Não utiliza o método `AuthenticationService.isAuthenticated` pois
      // ele também verifica se a sessão ainda está ativa. Aqui, apenas
      // preciso saber se o usuário acessou o sistema recentemente
      return !this.$utils.Lang.isNullOrUndefined(
        this.$store.state.authenticationData
      );
    },
    showModuloMenu() {
      return !!this.modulo && !!this.moduloMenu.length;
    },
    user() {
      const { user } = this.$store.state;

      if (!user) {
        return {};
      }

      let email = null;

      if (Array.isArray(user.email)) {
        email = user.email.find(item => item.tipoEmail === "INSTITUCIONAL");

        if (!email) {
          email = user.email.find(item => item.tipoEmail !== "INSTITUCIONAL");
        }

        if (email) {
          email = email.email;
        }
      } else {
        email = user.email;
      }

      return {
        name: user.altName ? user.altName : user.name,
        email: email ? email : null
      };
    }
  },
  mounted() {
    let { sidenav, collapsible } = this.$refs;

    window.M.Sidenav.init(sidenav);

    if (this.modulos && this.modulos.length) {
      window.M.Collapsible.init(collapsible);
    }
  },
  methods: {
    logout() {
      AuthenticationService.deauthenticate()
        .then(() => {
          if (window._paq) {
            window._paq.push(["resetUserId"]);
          }

          this.$store.commit("setUser", null);
        })
        .catch(error => this.$notification.pushError(error.message));
    },/*
    openHelp() {
      window.open(this.helpUrl);
    }*/
  }
};
</script>

<style scoped>
.sidenav {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 0;
}

.sidenav li.expander {
  flex-grow: 1;
}

.sidenav .collapsible li a.collapsible-header {
  padding: 0 32px;
  color: rgb(148, 148, 148);
}

.sidenav .collapsible li div.collapsible-body li a {
  font-weight: 400;
  padding: 0 37.5px 0 45px;
}

.sidenav .user-view {
  margin-bottom: 0;
}

.sidenav .divider {
  margin: 0;
  flex: 0 0 auto;
}

.sidenav li /deep/ .accessibility-menu {
  height: 48px;
}

.sidenav li /deep/ .accessibility-menu a {
  color: white;
}

.sidenav li /deep/ .accessibility-menu a i.material-icons {
  margin: 0;
}

/* Ajuste para aumentar a seletividade das regras de alto contraste */
.contrast .sidenav .accessibility-menu {
  background-color: black !important;
}
</style>

<style>
/* Ajuste para aumentar a seletividade das regras de alto contraste */
.contrast .sidenav-overlay {
  background-color: transparent !important;
}

.sidenav-overlay {
  z-index: 0;
}
</style>
